import { render, staticRenderFns } from "./RecordControl.vue?vue&type=template&id=47a9cfae&scoped=true"
import script from "./RecordControl.vue?vue&type=script&lang=js"
export * from "./RecordControl.vue?vue&type=script&lang=js"
import style0 from "./RecordControl.vue?vue&type=style&index=0&id=47a9cfae&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a9cfae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47a9cfae')) {
      api.createRecord('47a9cfae', component.options)
    } else {
      api.reload('47a9cfae', component.options)
    }
    module.hot.accept("./RecordControl.vue?vue&type=template&id=47a9cfae&scoped=true", function () {
      api.rerender('47a9cfae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecordControl/RecordControl.vue"
export default component.exports